import {IQuotePayType} from "./IQuotePayType";
import {IQuoteOption} from "./IQuoteOption";
import {IndirectQuoteType} from "../../Data/IndirectQuoteType";

export interface IQuote extends IQuoteBase {
  id: string;
  amsscore: number;
  scoreJson?: string;
  carSalePrice?: number;
  deferredDown?: number;
  tradeAllowance?: number;
  tradeLien?: number;
  fees?: number;
  taxTitleAndLicense?: number;
  rebate?: number;
  serviceContract?: number;
  creditLifeInsurance?: number;
  disabilityInsurance?: number;
  gapInsurance?: number;
  docFee?: number;
  taxes?: number;
  other?: number;
  quotePayTypeId: string;
  balloonTerm?: number;
  deleted: boolean;
  createdDate: Date;
  modifiedDate?: any;
  quotePayType?: IQuotePayType;
  discount?: number;
  availableIncome?: number;
  quoteType: IndirectQuoteType;
  transactionType: IndirectTransactionType;
  quoteOptions?: IQuoteOption[];
  overrideCalculatedTier?: boolean;
  
  // Dealer Check
  dealerPartialPercent?: number;
  dealerPartialAmount?: number;
  dealerReserve?: number;
  dealerReserveOverride?: number;
  commission?: number;
  dealerCheck?: number;
  
  /** Not saved to database. (memory-only field) */
  bankFee?: number;
  lenderFees?: number;
  quoteScores: IQuoteScore[];
}

export interface IQuoteScore {
  id?: string;
  scoreTypeId: string;
  score: number;
}

export interface IQuoteBase {
  payment?: number;
  term: number;
  apr?: number;
  pricingProgramId?: string;
  cashDown?: number;
  amountToFinance?: number;
  nadavalue?: number;
  quoteType?: IndirectQuoteType; // used for DealerFlow only
}

export interface IQuoteDecisionData extends IQuoteBase {
  useVehiclePrice: boolean;
  warranty?: number;
  bankFee?: number;
  tradeAllowance: number;
  balloonPayment: number;
  carSalePrice?: number;
  initialComment?: string;
  quotePayTypeId?: string; 
  dealerCheck?: number; // used for DealerFlow only 
}

export const copyQuote = (copyFromQuote: IQuote, copyToQuoteId: string, copyToQuoteType: IndirectQuoteType): IQuote => {
  return {
    ...copyFromQuote,
    quoteType: copyToQuoteType,
    id: copyToQuoteId
  };
}

export enum IndirectTransactionType {
  Retail = 0,
  PaymentCall = 1
}